import { FC, ReactNode, useMemo } from 'react'
import styles from 'components/features/pfm/LinkedAccountLayout/LinkedAccountLayout.styl'
import cn from 'classnames'
import { cssVar } from 'helpers/styleHelpers'

type LinkedAccountLayoutProps = {
  provider: ReactNode
  account: ReactNode
  balance: ReactNode
  category?: ReactNode
  actions: ReactNode
  sum?: ReactNode

  mode: 'byProvider' | 'byCategory'

  isFirst: boolean
  inSpan: number

  isUnlinked: boolean
}

export const LinkedAccountLayout: FC<LinkedAccountLayoutProps> = (props) => {
  const { mode, provider, account, balance, category, actions, sum, isFirst, inSpan, isUnlinked } = props

  const classNames = useMemo(() => cn(
    styles.linkedAccountLayout,
    styles[mode],
    isFirst && styles.isFirst,
    isUnlinked && styles.unlinked,
  ), [isFirst, mode, isUnlinked])

  const style = useMemo(() => cssVar({
    '--span-rows': mode === 'byProvider' ? inSpan : 0,
  }), [inSpan, mode])

  return (
    <div className={ classNames } style={ style }>
      <div className={ styles.provider }>
        <div className={ styles.providerContent }>
          { provider }
        </div>
      </div>
      <div className={ styles.account }>{ account }</div>
      <div className={ styles.balance }>{ balance }</div>
      <div className={ styles.category }>
        <div>{ category }</div>
        <div className={ styles.sum }>{ sum }</div>
      </div>
      <div className={ styles.actions }>{ actions }</div>
      <div className={ styles.leftPadding } />
      <div className={ styles.rightPadding } />
      <div className={ styles.bottomPadding } />
    </div>
  )
}
